import SiteBadgeCode from "../../../components/site-badge/SiteBadgeCode";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { useSiteContext } from "../../../context/siteContext";
import { useToast } from "../../../context/ToastContext";
import React, { useRef } from "react";
import { Typography } from "@mui/joy";

export default function SiteDsfPoster(props: RouteComponentProps) {
  const { site } = useSiteContext();
  const { session } = props;
  const site_id: string = session?.site_id || "";
  const client_id = session?.client_id;

  return (
    <>
      <Typography level="h2" component="h1">
        Site DSF Poster: {site?.name}
      </Typography>
      <SiteBadgeCode
        company_logo_s3_key={session.client_logo_s3_key}
        client_id={client_id}
        site_id={site_id}
        site_name={session.site_name}
        contact_details={site?.badge}
      />
    </>
  );
}
